import { log, pii } from "../log.js";
import { keywordRoute } from "./keyword-route.js";
import { meaningRoute } from "./meaning-route.js";
import { modelRoute } from "./model-route.js";
/**
 * One message's route (ADR 0040 §3, ADR 0042 as amended 2026-11-03): the phone's language model first; the phone's
 * embedding model, by nearest labelled saying, when the language model gives no route (none on this phone, too slow,
 * or a reply core rejected); the word lists when neither does. Chat text never leaves the phone for this.
 */
export async function routeChat(text, ctx, model, opts) {
    log.debug("chat: routing", { text: pii(text) });
    const byModel = await modelRoute(text, ctx, model, opts);
    const byMeaning = !byModel && opts?.meaning ? await meaningRoute(text, ctx, opts.meaning, opts) : undefined;
    const route = byModel ?? byMeaning ?? keywordRoute(text, ctx);
    // Who named it and what, never what was said.
    log.info("chat routed", { via: route.via, intent: route.intent });
    return route;
}
//# sourceMappingURL=route-chat.js.map